import { subYears } from "date-fns";
import { useFormikContext } from "formik";
import { ETaxonomy } from "library/types";
import { useTranslation } from "react-i18next";
import { TInputAppearance } from "theme/types";

import { helpAnchor } from "help/anchor";

import DatePickerField from "components/controls/DatePickerField";
import InputField from "components/controls/InputField";
import SelectField from "components/controls/SelectField";
import { Grid } from "components/styled";
import { useTaxonomyOptions } from "hooks/useTaxonomyOptions";

import { FieldsSectionTitle } from "./FieldsSectionTitle";

type Props = {
  isDependent?: boolean;
  appearance?: TInputAppearance;
};

export function MainFields({ isDependent, appearance = "underline" }: Props) {
  const { t } = useTranslation();
  const { values, setFieldValue, errors } = useFormikContext<FormData>();
  const genderOptions = useTaxonomyOptions(ETaxonomy.Gender);

  return (
    <>
      <FieldsSectionTitle title={t("hbh.personalInformation.label")} />
      <Grid
        data-help={isDependent ? helpAnchor("profile-dependent-name") : helpAnchor("profile-name")}
      >
        <InputField
          appearance={appearance}
          required
          label={t("hbh.firstName.label")}
          name="firstName"
          value={values["firstName"]}
          setFieldValue={setFieldValue}
          error={errors["firstName"]}
        />
        <InputField
          appearance={appearance}
          required
          label={t("hbh.lastName.label")}
          name="lastName"
          value={values["lastName"]}
          setFieldValue={setFieldValue}
          error={errors["lastName"]}
        />
        <InputField
          appearance={appearance}
          label={t("hbh.middleName.label")}
          name="middleName"
          value={values["middleName"]}
          setFieldValue={setFieldValue}
          error={errors["middleName"]}
        />
      </Grid>
      <Grid
        gridColumns={3}
        data-help={
          isDependent ? helpAnchor("profile-dependent-birth") : helpAnchor("profile-birth")
        }
      >
        <DatePickerField
          appearance={appearance}
          required
          maxDate={isDependent ? undefined : subYears(new Date(), 16)}
          name="dateOfBirth"
          value={values["dateOfBirth"]}
          setFieldValue={setFieldValue}
          label={t("hbh.dateOfBirth.label")}
          error={errors["dateOfBirth"]}
        />
        <InputField
          appearance={appearance}
          label={t("hbh.birthplace.label")}
          name="birthplace"
          value={values["birthplace"]}
          setFieldValue={setFieldValue}
          error={errors["birthplace"]}
        />
        <Grid gridColumns={2}>
          <SelectField
            appearance={appearance}
            error={errors["genderCodeId"]}
            setFieldValue={setFieldValue}
            value={values["genderCodeId"]}
            label={t("hbh.gender.label")}
            options={genderOptions}
            name={"genderCodeId"}
            showEmptyOption
          />
          <InputField
            appearance={appearance}
            label={t("hbh.personIdentificationNumber.label")}
            name="personIdentificationNumber"
            value={values["personIdentificationNumber"]}
            setFieldValue={setFieldValue}
            error={errors["personIdentificationNumber"]}
          />
        </Grid>
      </Grid>
      {/* <Grid>
        <InputField
          appearance={appearance}
          label={t("hbh.socialSecurityNumber.label")}
          name="socialSecurityNumber"
          value={values["socialSecurityNumber"]}
          setFieldValue={setFieldValue}
          error={errors["socialSecurityNumber"]}
        />
        <InputField
          appearance={appearance}
          label={t("hbh.passportNumber.label")}
          name="passportNumber"
          value={values["passportNumber"]}
          setFieldValue={setFieldValue}
          error={errors["passportNumber"]}
        /> */}
      {/* {isDependent && (
          <UploadFile
            key={values[isDependent ? "dependentCoverPhoto" : "employeeCoverPhoto"]?.path}
            setFieldValue={setFieldValue}
            fieldName={isDependent ? "dependentCoverPhoto" : "employeeCoverPhoto"}
            defaultValue={values[isDependent ? "dependentCoverPhoto" : "employeeCoverPhoto"]}
            label={t("hbh.chooseCoverPicture.label")}
          />
        )} */}
      {/* </Grid> */}
    </>
  );
}
